import React from "react";
import { ConfigurationSignatureHistoryView } from "../../views";
import {
  SignatureRequestService,
  LocalStorageService,
  ContractService,
} from "../../../services/index";

class ConfigurationSignatureHistoryAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      take: 6,
      showPagination: "",

      signatureRequests: [],
      signatureRequestsInitial: [],
      contractsClient: [],
      statusId: 0,

      contractId: 0,
      loading: false,
      optionsContracts: [],

      signatureInEdit: undefined,

      historyOfPlansItem: null,
      contractSendByProps: "",
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  signatureRequestService = new SignatureRequestService(this.url);
  contractService = new ContractService(this.url);

  async componentDidMount() {
    let historyOfPlansItem = this.props.location.state;
    if (historyOfPlansItem)
      this.setState({ historyOfPlansItem: { ...historyOfPlansItem.item } });
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");

    let requests =
      await this.signatureRequestService.getSignatureHistoryRequests(
        this.token
      );
    if (requests.data.length !== 0 && requests.data !== null) {
      requests.data = requests.data.dataSignRequests.map((signatureHistory) => {
        let temp = { ...signatureHistory };
        let serialContract = signatureHistory.contractId
          .slice(-5)
          .toUpperCase();
        signatureHistory.shortId = serialContract;
        signatureHistory.signsUsed = temp.signsUsed;
        return signatureHistory;
      });

      let contractsClient = await this.contractService.getContractsByClientId(
        this.token
      );

      this.setState({
        signatureRequests: requests.data,
        signatureRequestsInitial: requests.data,
        contractsClient,
        loading: false,
      });

      if (this.state.historyOfPlansItem !== null) {
        this.setState({
          contractSendByProps: this.state.historyOfPlansItem.contractId,
        });

        let signRequestFilterByProps = [];
        for (let i = 0; i < this.state.signatureRequests.length; i++) {
          if (
            this.state.signatureRequests[i].contractId ===
            this.state.historyOfPlansItem.contractId
          ) {
            signRequestFilterByProps.push(this.state.signatureRequests[i]);
          }
        }
        this.setState({ signatureRequests: signRequestFilterByProps });
      }

      await this.onChangeFooterInfoPagination();

      await this.onLoadFilterContracts();
    } else {
      this.setState({
        signatureRequests: "",
        signatureRequestsInitial: "",
        loading: false,
      });
    }
  }

  /**
   * @author Alan Aguilar
   * @date 19-11-2020
   * @description Change the rendering of a custom footer in the grid
   * @memberof ConfigurationSignatureHistoryAction
   */
  onChangeFooterInfoPagination = () => {
    let paginationInfoExist = document.querySelector(
      "#infoPaginationHistorySignatures"
    );
    if (paginationInfoExist) {
      paginationInfoExist.remove();
      this.setState({ showPagination: false });
    }

    let { signatureRequests, take, skip } = this.state;

    let totalItemsInTable = signatureRequests.length;
    if (signatureRequests.length !== 0) {
      this.setState({ showPagination: { info: false } }, () => {
        let currentPage = Math.floor(skip / take) + 1;
        let totalPages = Math.ceil((totalItemsInTable || 0) / take);

        let firstItemInPage = skip + 1;
        let lastItemInPage = 0;
        if (currentPage === totalPages) {
          lastItemInPage = totalItemsInTable;
        } else {
          lastItemInPage = skip + take;
        }

        let totalSingsByColumn = 0;
        let signsByColumn = document.querySelectorAll('td[id="signsUsed"]');
        signsByColumn.forEach(function (item) {
          totalSingsByColumn += Number(item.innerText);
        });

        let footerPagination = document.querySelector('div[role="navigation"]');
        if (footerPagination) {
          let element = document.createElement("div");
          element.id = "infoPaginationHistorySignatures";
          element.innerHTML = `<span className='configurationSignatureHistoryPanelPure-footerGrid'>${totalSingsByColumn} ${totalSingsByColumn === 1 ? "Crédito" : "Créditos"
            }</span><span style="margin-left: 20px; margin-right: 10px">${firstItemInPage} - ${lastItemInPage} de ${totalItemsInTable} Solicitudes</span> <span style=" margin-right: 25px;">${currentPage}/${totalPages}</span>`;
          element.className = "k-pager-info k-label";
          footerPagination.appendChild(element);
        }
      });
    } else {
      this.setState({ showPagination: false });
    }
  };

  /**
   * @author Alan Aguilar
   * @date 20-11-2020
   * @description Reload the table for filter the signRequest by ContractId
   * @memberof ConfigurationSignatureHistoryAction
   */
  onFilterContracts = async (event) => {
    let contractId = event.target.value;

    let { signatureRequestsInitial } = this.state;
    if (contractId && contractId !== "0") {
      let filterSignatureRequest = [];
      for (let i = 0; i < signatureRequestsInitial.length; i++) {
        if (signatureRequestsInitial[i].contractId === contractId) {
          filterSignatureRequest.push(signatureRequestsInitial[i]);
        }
      }
      this.setState(
        {
          signatureRequests: filterSignatureRequest,
          contractId,
          loading: false,
        },
        () => {
          this.onChangeFooterInfoPagination();
        }
      );
    } else {
      this.setState(
        {
          signatureRequests: signatureRequestsInitial,
          contractId: 0,
          loading: false,
        },
        () => {
          this.onChangeFooterInfoPagination();
        }
      );
    }
  };

  getHistoryOfPlansItem = async ({ id }) => {
    this.setState({ loading: true }, () => {
      let contractId = id;

      if (contractId && contractId !== "0") {
        let { signatureRequests } = this.state;
        let filterSignatureRequest = [];
        for (let i = 0; i < signatureRequests.length; i++) {
          if (signatureRequests[i].userContract.id === contractId) {
            filterSignatureRequest.push(signatureRequests[i]);
          }
        }
        this.setState(
          {
            signatureRequests: filterSignatureRequest,
            contractId,
            loading: false,
          },
          () => this.onChangeFooterInfoPagination()
        );
      } else {
        let { signatureRequestsInitial } = this.state;
        this.setState(
          {
            signatureRequests: signatureRequestsInitial,
            contractId: 0,
            loading: false,
          },
          () => this.onChangeFooterInfoPagination()
        );
      }
    });
  };

  /**
   * @author Alan Aguilar
   * @date 20-11-2020
   * @description Load the option tags in the "select contracts"
   * @memberof ConfigurationSignatureHistoryAction
   */
  onLoadFilterContracts = async () => {
    let { contractsClient, contractSendByProps } = this.state;

    if (contractsClient.length > 0) {
      let optionsRendered = contractsClient.map((item, index) => {
        let shortId = item.id.slice(-5).toUpperCase();
        return (
          <option key={index} value={item.id}>
            {shortId}
          </option>
        );
      });
      this.setState({ optionsContracts: optionsRendered });
    }

    if (contractSendByProps) {
      this.setState({ contractId: contractSendByProps });
    }
  };

  /**
   * @author Lucia Alvarado
   * @description Change page in paginnation of table
   * @param {Object} dataItem
   * @memberof ConfigurationSignatureHistoryAction
   */
  onPageChange = (event) => {
    this.setState(
      {
        skip: event.page.skip,
        take: event.page.take,
      },
      () => {
        this.onChangeFooterInfoPagination();
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Edit a signer
   * @param {Object} dataItem
   * @memberof ConfigurationSignatureHistoryAction
   */
  edit = (dataItem) => {
    this.setState({
      signatureInEdit: this.cloneSignature(dataItem),
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Duplicate data signature for the grid
   * @param {Object} signer
   * @memberof ConfigurationSignatureHistoryAction
   */
  cloneSignature(signature) {
    return Object.assign({}, signature);
  }

  /**
   * @author  Lucia Alvarado
   * @description Method to move scroll
   * @memberof ConfigurationSignatureHistoryAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <ConfigurationSignatureHistoryView
        {...this.state}
        onPageChange={this.onPageChange}
        onChangeFooterInfoPagination={this.onChangeFooterInfoPagination}
        getHistoryOfPlansItem={this.getHistoryOfPlansItem}
        onFilterContracts={this.onFilterContracts}
        edit={this.edit}
        scrollWindow={this.scrollWindow}
      />
    );
  }
}

export { ConfigurationSignatureHistoryAction as default };
